import { z } from 'zod';

export const pipelineSnapshotCountsSchema = z.object({
  draft: z.number(),
  inProgress: z.number(),
  pendingApproval: z.number(),
  approved: z.number(),
  scheduled: z.number(),
  published: z.number(),
});

export type PipelineSnapshotCounts = z.infer<typeof pipelineSnapshotCountsSchema>;

export const pipelineClientSnapshotSchema = z.object({
  clientId: z.string(),
  clientName: z.string(),
  counts: pipelineSnapshotCountsSchema,
  previousCounts: pipelineSnapshotCountsSchema,
});

export type PipelineClientSnapshot = z.infer<typeof pipelineClientSnapshotSchema>;

export const pipelineSnapshotSchema = z.object({
  window: z.object({
    fromDate: z.string(),
    toDate: z.string(),
  }),
  previousWindow: z.object({
    fromDate: z.string(),
    toDate: z.string(),
  }),
  counts: pipelineSnapshotCountsSchema,
  previousCounts: pipelineSnapshotCountsSchema,
  clientBreakdown: z.array(pipelineClientSnapshotSchema),
});

export type PipelineSnapshotSchema = z.infer<typeof pipelineSnapshotSchema>;
